module.exports = __webpack_public_path__ + "static/img/bannerBg5_en.7d25618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bannerBg5_en.png
// module id = 7UxJ
// module chunks = 1